// Shared instrumentation seams — fire GA (analytics.ts) + the per-user Firestore counter
// (usageCounter.ts) together, fully fire-and-forget. Nothing here throws or blocks a
// generation/export: track() swallows its own errors and the counter writes are voided.
// A defensive try/catch guards the (synchronous) track() call so a bad param can never
// bubble into a call site's success/catch path.
import { track } from "./analytics";
import { incrementGeneration, incrementExport } from "./usageCounter";
import type { Mode } from "@/types/roast";
import type { DetectedSourceType } from "./createFlow";
import type { StageId } from "./runGeneration";
import type { DeliverOutcome } from "./deliverVideo";

export function recordGeneration(args: {
  email: string | null;
  uid: string | null;
  mode: Mode;
  source: DetectedSourceType;
}): void {
  try {
    const { email, uid, mode, source } = args;
    track("generate", { mode, source });
    if (email) {
      void incrementGeneration(email, uid, mode).catch((e) => console.warn("[usage] increment failed", e));
    }
  } catch { /* fire-and-forget */ }
}

export function recordGenerationFailed(args: {
  source: DetectedSourceType;
  stage: StageId;
}): void {
  try {
    track("generate_failed", { source: args.source, stage: args.stage });
  } catch { /* fire-and-forget */ }
}

export function recordExport(args: {
  email: string | null;
  uid: string | null;
  outcome: Exclude<DeliverOutcome, "cancelled">;
  source: DetectedSourceType;
  isTouch: boolean;
}): void {
  try {
    const { email, uid, outcome, source, isTouch } = args;
    track("export_video", { outcome, source, is_touch: isTouch });
    if (email) {
      void incrementExport(email, uid).catch((e) => console.warn("[usage] increment failed", e));
    }
  } catch { /* fire-and-forget */ }
}

export function recordExportCancelled(args: {
  source: DetectedSourceType;
  isTouch: boolean;
}): void {
  try {
    track("export_cancelled", { source: args.source, is_touch: args.isTouch });
  } catch { /* fire-and-forget */ }
}
